module.exports = __webpack_public_path__ + "img/icon-issue-holding.01083546.svg";